import { gql } from '@apollo/client';

export const CREATE_ASSET = gql`
  mutation CreateAsset($data: AssetCreateInput!) {
    createAsset(data: $data) {
      id
      url
      upload {
        status
        expiresAt
        error {
          code
          message
        }
        requestPostData {
          url
          date
          key
          signature
          algorithm
          policy
          credential
          securityToken
        }
      }
    }
  }
`;
